export default __webpack_public_path__ + "static/media/btn-black-m.fdd35587.webp";